import React from "react";
import { useDispatch } from "react-redux";
import EditModal from "../common/EditModal";
import { updateStudent } from "../../redux/actions/admin/studentAction";

const EditAddEnrollStudentBatch = ({
  id,
  name,
  email,
  phone,
  parentName,
  parentEmail,
  parentPhone,
  feesDeposit,
  courseFees,
  refreshData,
}) => {
  const dispatch = useDispatch();
  const formFields = [
    {
      name: "name",
      label: "Student Name",
      value: name,
      placeholder: "Student Name",
    },
    {
      name: "email",
      label: "Student Email",
      value: email,
      placeholder: "Student Email",
    },
    {
      name: "phone",
      label: "Student Phone",
      value: phone,
      placeholder: "Student Phone",
    },
    {
      name: "parentName",
      label: "Parent Name",
      value: parentName,
      placeholder: "Parent Name",
    },
    {
      name: "parentEmail",
      label: "Parent Email",
      value: parentEmail,
      placeholder: "Parent Email",
    },
    {
      name: "parentPhone",
      label: "Parent Phone",
      value: parentPhone,
      placeholder: "Parent Phone",
    },
    {
      name: "feesDeposit",
      label: "Student Fees Deposit",
      value: feesDeposit,
      placeholder: "Course Fees",
    },
    {
      name: "courseFees",
      label: "Course & Class Fees",
      value: courseFees,
      placeholder: "Course & Class Fees",
    },
  ];

  // Handle the student data update
  const handleUpdate = async (studentData) => {
    await dispatch(updateStudent(id, studentData));
    refreshData();
  };
  return (
    <>
      <EditModal
        title="Edit Student Details"
        formFields={formFields}
        onSubmit={handleUpdate}
        buttonName="Update Student"
        modelTitle="Are you sure you want to edit these Student details?"
        content="Please confirm to apply the changes mode to this student."
        okText="Yes, Change"
        cancelText="No, Cancel"
      />
    </>
  );
};

export default EditAddEnrollStudentBatch;
